<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div>
  <!-- <div class="d-flex justify-content-between align-items-center wccard p-3" style="background: linear-gradient(to left, #FFFFFF 0%, #F2F2F2 100%);">
    <div class="d-flex flex-column">
      <span class="f-20 font-weight-600" style="color: #484B59;">Settings</span>
      <span class="f-14 font-weight-400" style="color: #484B59; margin-top: 9px;">Manage your organization’s settings — including team access, integrations, account preferences,</span>
      <span class="f-14 font-weight-400" style="color: #484B59;"> credit usage, and profile details — all in one place.</span>
    </div>

    <div>
      <img style="width: 62px; height: 62px;" src="../../assets/vector.svg" alt="setting_icon">
    </div>
  </div> -->

  <div class="row mt-3 mx-0">
    <div class="col-md-3 pl-0 bg-white">
      <div class="wccard p-3">
        <div class="header-text">
          <p *ngIf="showProfileTab || showTagManagementTab" class="f-14" style="color: #484B59;"><i
              class="fa-solid fa-user"></i></p>
          <p *ngIf="!showProfileTab && !showTagManagementTab" class="f-14" style="color: #484B59;"><i
              class="fa-regular fa-user"></i></p>
          <p class="f-14 ml-2 font-weight-600" style="color: #484B59;">Account</p>
        </div>
        <div class="left-border">
          <p [ngClass]="showProfileTab ? 'active' : '' " (click)="onTabChange('profile')">Profile Details</p>
          <p [ngClass]="showTagManagementTab ? 'active' : '' " (click)="onTabChange('tag-management')">Tag Management
          </p>
        </div>

        <div class="header-text">
          <p *ngIf="showPlanTab || showCreditsTab || showTeamManagementTab" class="f-14" style="color: #484B59;"><i
              class="fa-solid fa-file"></i></p>
          <p *ngIf="!showPlanTab && !showCreditsTab && !showTeamManagementTab" class="f-14" style="color: #484B59;"><i
              class="fa-regular fa-file"></i></p>
          <p class="f-14 ml-2 font-weight-600" style="color: #484B59;">Organization</p>
        </div>
        <div class="left-border">
          <p [ngClass]="showPlanTab ? 'active' : '' " (click)="onTabChange('plan')">Plan</p>
          <p [ngClass]="showCreditsTab ? 'active' : '' " (click)="onTabChange('credits')">Credits</p>
          <p [ngClass]="showTeamManagementTab ? 'active' : '' " (click)="onTabChange('team-management')">Team Management
          </p>
        </div>

        <div class="header-text">
          <p *ngIf="showEmailTemplatesTab || showCampaignsLimitsTab" class="f-14" style="color: #484B59;"><i class="fa-solid fa-envelope"></i></p>
          <p *ngIf="!showEmailTemplatesTab && !showCampaignsLimitsTab" class="f-14" style="color: #484B59;"><i class="fa-regular fa-envelope"></i>
          </p>
          <p class="f-14 ml-2 font-weight-600" style="color: #484B59;">Email</p>
        </div>
        <div class="left-border">
          <p [ngClass]="showEmailTemplatesTab ? 'active' : '' "
            [ngStyle]="{'color': showEmailTemplatesTab ? '#2E93A1': '#484B59'}"
            (click)="onTabChange('email-templates')">Email Templates</p>
          <p [ngClass]="showCampaignsLimitsTab ? 'active' : '' "
            [ngStyle]="{'color': showCampaignsLimitsTab ? '#2E93A1': '#484B59'}"
            (click)="onTabChange('campaigns-limits')">Campaigns Limits</p>
        </div>

        <div class="header-text" *ngIf="isteamAdmin">
          <p *ngIf="showAutopilotPermissionTab" class="f-14" style="color: #484B59;"><img
              style="width: 25px; height: 25px; padding: 0px;" src="../../assets/ai-sourcing/webbtree_sidebar.svg"
              alt="ai_sourcing"></p>
          <p *ngIf="!showAutopilotPermissionTab" class="f-14" style="color: #484B59;"><img
              style="width: 25px; height: 25px; padding: 0px;" src="../../assets/ai-sourcing/webbtree_sidebar.svg"
              alt="ai_sourcing">
          </p>
          <p class="f-14 ml-2 font-weight-600" style="color: #484B59;">Autopilot<sup class=""
              style="top: 0px!important;"><span>AI</span></sup></p>
        </div>
        <div class="left-border" *ngIf="isteamAdmin">
          <p [ngClass]="showAutopilotPermissionTab ? 'active' : '' " (click)="onTabChange('autopilot-permission')">
            Permission</p>
        </div>

        <div class="header-text">
          <p *ngIf="showEmailIntegrationTab || showAtsIntegrationTab" class="f-14" style="color: #484B59;"><i
              class="fa-solid fa-puzzle"></i></p>
          <p *ngIf="!showEmailIntegrationTab && !showAtsIntegrationTab" class="f-14" style="color: #484B59;"><i
              class="fa-regular fa-puzzle"></i></p>
          <p class="f-14 ml-2 font-weight-600" style="color: #484B59;">Integrations</p>
        </div>

        <div class="left-border">

          <p [ngClass]="showEmailIntegrationTab ? 'active' : '' " (click)="onTabChange('email-integrations')">Email
            Integrations</p>
          <p [ngClass]="showAtsIntegrationTab ? 'active' : '' " (click)="onTabChange('ats-integrations')">ATS
            Integrations</p>
        </div>
      </div>
    </div>

    <div class="col-md-9 body-scroller">
      <div class="ml-3">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
